import { PlatformHero } from '../../components/sections/platform/PlatformHero'
import { ModuleOverview } from '../../components/sections/platform/ModuleOverview'
import { FeatureGrid } from '../../components/sections/platform/FeatureGrid'
import { MetricsSection } from '../../components/sections/platform/MetricsSection'
import { ModuleFAQ } from '../../components/sections/platform/ModuleFAQ'
import { PlatformCTA } from '../../components/sections/platform/PlatformCTA'
import { ModuleNav } from '../../components/sections/platform/ModuleNav'

export function BrainPage() {
  return (
    <>
      <PlatformHero tKey="brain" />
      <ModuleOverview tKey="brain" />
      <FeatureGrid tKey="brain" />
      <MetricsSection tKey="brain" />
      <ModuleFAQ tKey="brain" />
      <PlatformCTA />
      <ModuleNav />
    </>
  )
}
